import styled from 'styled-components';
import { Text } from '@lux/text';
export const BrandText = styled(Text).withConfig({ displayName: "BrandText", componentId: "sc-1p62xgt" }) `margin-left:2px;`;
//# sourceMappingURL=rating.styled.js.map